import React from "react";
import { Button } from "../ui/button";
import AdminImageWithFallback from "./AdminImageWithFallback";

/**
 * Concise production-order card for the Priority Center: image, one title
 * line, one order/product line, one customer/personalization line, and the
 * existing Open Order action.
 */
export default function PriorityOrderCard({ alert, onOpen, onAcknowledge, acknowledgeBusy = false }) {
  return (
    <article className="grid gap-3 border-l-4 border-amber-400 bg-amber-950/10 p-3 sm:grid-cols-[56px_1fr_auto] sm:items-center">
      <AdminImageWithFallback
        src={alert.image_url}
        alt=""
        className="h-14 w-14 rounded object-cover"
      />
      <div className="min-w-0">
        <p className="font-semibold text-stone-100">{alert.title}</p>
        <p className="truncate text-sm text-stone-300">
          {alert.order_id.slice(0, 8).toUpperCase()} · {alert.product}
          {alert.variant ? ` — ${alert.variant}` : ""} · Qty {alert.quantity}
        </p>
        <p className="text-sm text-stone-400">
          {alert.customer} · Personalization:{" "}
          {String(alert.personalization_status || "").replaceAll("_", " ")} ·{" "}
          {alert.age_hours}h old
        </p>
      </div>
      <div className="flex shrink-0 flex-wrap gap-2">
        <Button className="w-full sm:w-auto" onClick={() => onOpen(alert.order_id)}>
          Open Order
        </Button>
        {onAcknowledge && (
          <Button
            variant="outline"
            className="w-full sm:w-auto bg-transparent border-stone-100/15 text-stone-200 hover:bg-stone-100/5"
            disabled={acknowledgeBusy}
            onClick={() => onAcknowledge(alert.id)}
            data-testid={`acknowledge-${alert.id}`}
          >
            {acknowledgeBusy ? "Acknowledging..." : "Acknowledge"}
          </Button>
        )}
      </div>
    </article>
  );
}
